import React, { Component } from 'react';

import { Dialog, Grid, Button, Checkbox } from '@icedesign/base';

import { formatMessage } from '@/i18n';
import Colors from '@/tool/Colors';

import './style.scss';

const { Row, Col } = Grid;

export default class ScreenModeDialog extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isWideScreen: props.wideScreen,
      visible: false,
    };
  }

  confirm = () => {
    const { onSelect } = this.props;
    const { isWideScreen } = this.state;
    // eslint-disable-next-line no-unused-expressions
    onSelect?.(isWideScreen);
    this.close();
  };

  close = () => {
    this.setState({ visible: false });
  };

  open = wideScreen => {
    this.setState({ visible: true, isWideScreen: wideScreen });
  };

  render() {
    const { isWideScreen, visible } = this.state;
    return (
      <Dialog
        className="widescreen-dialog"
        visible={visible}
        title={formatMessage('system.screen.mode')}
        onClose={this.close}
        style={styles.dialog}
        closable="esc,close,mask"
        footer={
          <div>
            <Button
              type="primary"
              style={{ width: 120, height: 35, marginTop: 10 }}
              onClick={this.confirm}
            >
              {formatMessage('system.screen.mode.experience')}
            </Button>
          </div>
        }
      >
        <div>
          <div style={styles.desc}>{formatMessage('system.screen.mode.desc')}</div>
          <Row align="center" justify="space-between">
            <Col span="11">
              <ModeItem
                icon={require('./images/wide.png')}
                title={`👍 ${formatMessage('system.screen.mode.wide')}`}
                subtitle={formatMessage('system.screen.mode.wide.desc')}
                onClick={() => {
                  this.setState({
                    isWideScreen: true,
                  });
                }}
                selected={isWideScreen}
              />
            </Col>
            <Col span="11">
              <ModeItem
                icon={require('./images/narrow.png')}
                title={formatMessage('system.screen.mode.narrow')}
                subtitle={formatMessage('system.screen.mode.narrow.desc')}
                onClick={() => {
                  this.setState({
                    isWideScreen: false,
                  });
                }}
                selected={!isWideScreen}
              />
            </Col>
          </Row>
        </div>
      </Dialog>
    );
  }
}

const ModeItem = ({ icon, title, subtitle, selected, onClick }) => {
  return (
    <div>
      <div style={{ ...styles.item, ...(selected ? styles.itemSelected : {}) }} onClick={onClick}>
        <img src={icon} style={styles.icon} />

        <Row justify="center">
          <div style={styles.subtitle}>{subtitle}</div>
        </Row>
      </div>
      <Row align="center" justify="center" style={styles.bottom}>
        <Checkbox checked={selected} onChange={onClick} />
        &nbsp;&nbsp;
        <div style={styles.title} onClick={onClick}>
          {title}
        </div>
      </Row>
    </div>
  );
};

const styles = {
  dialog: {
    width: 660,
    padding: 20,
  },
  desc: {
    marginBottom: 35,
    fontSize: 16,
  },
  item: {
    textAlign: 'center',
    padding: '35px 10px',
    // margin: 15,
    borderWidth: 2,
    borderStyle: 'solid',
    borderColor: Colors.lightGrey,
    borderRadius: 8,
  },
  itemSelected: {
    borderColor: Colors.primary,
    boxShadow: `0px 0px 8px ${Colors.primary}`,
  },
  icon: {
    width: 100,
    height: 100,
    marginBottom: 15,
  },
  bottom: {
    marginBottom: 10,
    marginTop: 20,
  },
  title: {
    fontSize: 16,
    fontWeight: 'bold',
    cursor: 'default',
  },
  subtitle: {
    fontSize: 14,
    color: Colors.lightGrey,
    width: 230,
  },
};
